import { useState } from "react"
import { ChevronDown } from "zudoku/icons"

const faqs = [
    {
        question: "What is the CBN Regulatory Sandbox?",
        answer: "The CBN Regulatory Sandbox is a secure, controlled testing environment established to simulate the Central Bank of Nigeria's (CBN) regulatory parameters, enabling participants to demonstrate the operational viability and regulatory alignment of their financial products prior to market deployment.",
    },
    {
        question: "Who is eligible to participate in the Sandbox?",
        answer: "Eligibility is extended to Fintech startups, established Financial Service Providers (FSPs), licensed commercial banks, and technology innovators developing products for the Nigerian financial market, provided they meet the CBN's stipulated application criteria.",
    },
    {
        question: "Does participation in the sandbox guarantee final licensure?",
        answer: "No, participation does not constitute a guarantee of final licensure. However, the testing phase provides a mechanism to generate automated evidence of compliance and operational data, which streamlines the assessment and review phase of the official licensing pipeline.",
    },
    {
        question: "How does the sandbox streamline the CBN licensing assessment?",
        answer: "The CBN Sandbox mandates rigorous validation of the operational model, automatically generating the structured regulatory data and performance reports required by the CBN to assess suitability for provisional or operational licenses.",
    },
    {
        question: "What is the mechanism for automated regulatory reporting?",
        answer: "The Application Programming Interfaces (APIs) facilitate the direct, secure transmission of market activity data from the participant's system to the CBN's regulatory supervision dashboards, thereby providing real-time evidence of compliance posture and mitigating data submission risk.",
    },
    {
        question: "What categories of innovation can be tested?",
        answer: "The CBN Sandbox is designed to accommodate the testing of payment system innovations, cross-border remittance, proprietary lending algorithms, and virtual asset services, all within the CBN Sandbox framework.",
    },
]

export const FAQ = ({ className }: { className?: string }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null)

    return (
        <section {...{ className }}>
            <div className="max-w-3xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold mb-4">Frequently Asked Questions</h2>
                    <p className="text-lg text-muted-foreground">
                        Everything you need to know about the CBN Regulatory Sandbox.
                    </p>
                </div>
                <div className="space-y-2">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="border border-border rounded-xl overflow-hidden transition-all duration-200"
                        >
                            <button
                                onClick={() =>
                                    setOpenIndex(openIndex === index ? null : index)
                                }
                                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-muted/50 transition-colors"
                            >
                                <span className="font-medium pr-4">{faq.question}</span>
                                <ChevronDown
                                    className={`flex-shrink-0 h-5 w-5 text-muted-foreground transition-transform duration-200 ${
                                        openIndex === index ? "rotate-180" : ""
                                    }`}
                                />
                            </button>
                            {openIndex === index && (
                                <div className="px-6 pb-5 text-muted-foreground leading-relaxed text-sm border-t border-border pt-4">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}